import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					title={"Harvey Senior High School"}
					image={require('./video.jpg')}
					bg="#0b2f33"
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A regional school looking for a modern online look.</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/harvey.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi sat down with the school to work who will use the website, building it around their needs.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Website Design <a href="https://www.harveyshs.wa.edu.au/" target="_blank">harveyshs.wa.edu.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Easy to navigate and find important information</li>
									<li>Responsive design to work on all devices</li>
									<li>Animated elements for smooth flow</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Harvey Senior High School" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Harvey Senior High School" width="100%" />
								<img src={require('./example-2.jpg')} alt="Harvey Senior High School" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/Harvey/index.js